import {
  ApiCallCardDotMenuItemComponent,
  ApiCallCardDotMenuItemComponentProps,
} from "./ApiCallCardDotMenuItemComponent";
import {
  NewFormModalCardDotMenuItemComponent,
  NewFormModalCardDotMenuItemComponentProps,
} from "./NewFormModalCardDotMenuItemComponent";

export const CardDotMenuItemComponent = (props: {
  props: CardDotMenuItemComponentProps;
  cardData: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <>
      {props.props.type === "api_call" && (
        <ApiCallCardDotMenuItemComponent
          props={props.props}
          cardData={props.cardData}
          setReloadKey={props.setReloadKey}
          pageData={props.pageData}
          setPageData={props.setPageData}
        />
      )}
      {props.props.type === "new_form_modal" && (
        <NewFormModalCardDotMenuItemComponent
          props={props.props}
          cardData={props.cardData}
          setReloadKey={props.setReloadKey}
          pageData={props.pageData}
          setPageData={props.setPageData}
        />
      )}
    </>
  );
};

export type CardDotMenuItemComponentProps =
  | ApiCallCardDotMenuItemComponentProps
  | NewFormModalCardDotMenuItemComponentProps;
